import axios from 'axios';
import { FIREBASE_API_KEY, LIVESTREAM_API_URL, PROXY_WORKER_URL } from 'appenv';
import {
  defer, from, of, timer,
} from 'rxjs';
import {
  map, mergeMap, retry, tap,
} from 'rxjs/operators';

export interface LiveStreamTokenResponse {
  agoraToken: string;
  realtimeDBToken: string;
}

const createLiveStreamTokenObservable = (
  boothId: string, agoraAccount: string, userRole: 'audience' | 'host',
) => defer(() => timer(0, 15 * 60 * 1000)).pipe(
  mergeMap(() => axios.get(`${LIVESTREAM_API_URL}/token?boothId=${boothId}&userAccount=${agoraAccount}&userRole=${userRole}&objectResult=true`, {
    headers: {
      Authorization: 'Bearer TODO', // TODO
    },
  })),
  map((resp) => resp.data.result as { agoraToken: string, realtimeDBCustomToken: string }),
  mergeMap(
    ({ agoraToken, realtimeDBCustomToken }) => (realtimeDBCustomToken == null ? of({
      agoraToken,
      realtimeDBToken: null,
    }) : from(axios.post(
      `${PROXY_WORKER_URL}/v1/accounts:signInWithCustomToken?eventx_url=identitytoolkit.googleapis.com&key=${FIREBASE_API_KEY}`, {
        token: realtimeDBCustomToken,
        returnSecureToken: true,
      },
    )).pipe(
      map(({ data: { idToken, refreshToken, expiresIn } }) => ({
        agoraToken,
        realtimeDBToken: idToken,
      } as LiveStreamTokenResponse)),
    )),
  ),
  retry(3),
);

export default createLiveStreamTokenObservable;
